'use client';
import DownloadProfileItem from './DownloadProfileItem';

export interface ProfileItem {
  id: string;
  name: string;
  description: string;
  visibility: string;
  url: string;
  index_url: string;
  offline_archive_url: string;
}

export type ProfileFamily = Record<string, ProfileItem[]>;

// {
//     "name": "Prusa SLA",
//     "description": "Prusa SLA printers",
//     "visibility": "",
//     "id": "prusa-sla",
//     "url": "https://preset-repo-api-stage.prusa3d.com/v1/repos/prusa-sla",
//     "index_url": "https://preset-repo-api-stage.prusa3d.com/v1/repos/prusa-sla/vendor_indices.zip",
//     "offline_archive_url": "https://storage.googleapis.com/prusa3d-content-stage-e60a-preset-repo-api-public/prusa-sla/prusa-sla-offline.zip"
//   },

interface DownloadProfilesProps {
  profiles: ProfileFamily | null;
}

export default function DownloadProfiles({
  profiles: families,
}: DownloadProfilesProps) {
  if (!families) return null;

  return (
    <div>
      {Object.entries(families).map(([familyId, profiles], index) => (
        <>
          <h2 key={index}>{familyId}</h2>
          {Array.isArray(profiles) &&
            profiles.map((profile, index) => (
              <DownloadProfileItem key={index} profile={profile} />
            ))}
        </>
      ))}
    </div>
  );
}
